/* eslint-disable max-lines */ //TODO fix max lines
/* eslint-disable complexity */ //TODO fix complexity lines

import { Injectable } from '@angular/core';
import { TimeoutError } from 'rxjs';
import { ERROR_MSG_TIMEOUT_ERROR } from '../../../constants';
import {
  AddMfaBackup,
  Authenticate,
  CancelAuthentication,
  CancelPairing,
  CheckNewPassword,
  ContinueAuthentication,
  FlyDeltaPoll,
  InitiateAccountRecovery,
  InitiateAuthentication,
  InitiatePasswordChange,
  InitiateSsoSession,
  InitiateUserRegistration,
  SelectDevice,
  SubmitEmailOtp,
  SubmitEmailResponse,
  SubmitFlyDeltaMethod,
  SubmitNewPassword,
  SubmitSkymilesNumber,
  SubmitSmsNumber,
  SubmitSmsOtp,
  SubmitUserRegistration
} from '../../../models';
import { MfaUtilHelperService } from './mfa-util-helper.service';
@Injectable({
  providedIn: 'root'
})
export class MfaUtilService extends MfaUtilHelperService {
  getMfaRegistrationError(
    response:
      | InitiateAuthentication
      | SubmitEmailOtp
      | CancelAuthentication
      | AddMfaBackup
      | ContinueAuthentication
      | SubmitFlyDeltaMethod
      | SubmitSmsNumber
      | SubmitSmsOtp
      | InitiateUserRegistration
      | SubmitUserRegistration
      | FlyDeltaPoll
      | CancelPairing
      | InitiateSsoSession
      | InitiatePasswordChange
      | CheckNewPassword
      | InitiateAccountRecovery
      | InitiateSsoSession
      | SubmitSkymilesNumber
      | Authenticate
      | SelectDevice
      | SubmitEmailResponse
      | SubmitNewPassword
  ): string {
    if (response instanceof TimeoutError) {
      return ERROR_MSG_TIMEOUT_ERROR;
    }

    if (response?.error?.details && response?.error?.details[0]?.code) {
      this.errorCode =
        `ERROR_MSG_${response?.error?.details[0]?.code}`.toUpperCase();
      if (
        this.errorCode === 'ERROR_MSG_OTP_ATTEMPTS_LIMIT' ||
        this.errorCode === 'ERROR_MSG_TOTP_ATTEMPTS_LIMIT'
      ) {
        const coolDownTimer = response?.error?.details[0]?.coolDownExpiresAt;
        if (coolDownTimer) {
          this.coolDownTimer = coolDownTimer;
        } else {
          this.coolDownTimer = undefined;
        }
        this.remainingAttempt$.next(
          response?.error?.details[0]?.attemptsRemaining
            ? response?.error?.details[0].attemptsRemaining
            : 0
        );
      }
      if (
        this.errorCode === 'ERROR_MSG_INVALID_OTP' &&
        response?.error?.details[0]?.attemptsRemaining
      ) {
        this.remainingAttempt$.next(
          response?.error?.details[0]?.attemptsRemaining
        );
      }
    } else {
      this.checkMFAErrors(response);
    }
    return this.errorCode;
  }

  checkMFAErrors(
    response:
      | InitiateAuthentication
      | SubmitEmailOtp
      | CancelAuthentication
      | AddMfaBackup
      | ContinueAuthentication
      | SubmitFlyDeltaMethod
      | SubmitSmsNumber
      | SubmitSmsOtp
      | InitiateUserRegistration
      | SubmitUserRegistration
      | FlyDeltaPoll
      | CancelPairing
      | InitiateSsoSession
      | InitiatePasswordChange
      | CheckNewPassword
      | InitiateAccountRecovery
      | InitiateSsoSession
      | SubmitSkymilesNumber
      | Authenticate
      | SelectDevice
      | SubmitEmailResponse
      | SubmitNewPassword
  ) {
    if (this.checkForMFAErrors(response)) {
      const errorCode = response?.error?.code
        ? response?.error?.code
        : response?.code;
      this.errorCode = `ERROR_MSG_${errorCode}`.toUpperCase();
    } else if (response?.code === 'SERVER_ERROR') {
      this.errorCode = `ERROR_MSG_${response?.code}`.toUpperCase();
    }
  }

  getCoolDownTimer(): number | undefined {
    return this.coolDownTimer;
  }

  checkForMFAErrors(
    response:
      | InitiateAuthentication
      | SubmitEmailOtp
      | CancelAuthentication
      | AddMfaBackup
      | ContinueAuthentication
      | SubmitFlyDeltaMethod
      | SubmitSmsNumber
      | SubmitSmsOtp
      | InitiateUserRegistration
      | SubmitUserRegistration
      | FlyDeltaPoll
      | CancelPairing
      | InitiateSsoSession
      | InitiatePasswordChange
      | CheckNewPassword
      | InitiateAccountRecovery
      | InitiateSsoSession
      | SubmitSkymilesNumber
      | Authenticate
      | SelectDevice
      | SubmitEmailResponse
      | SubmitNewPassword
  ): boolean {
    return (
      this.checkResourceNotFoundError(response) ||
      this.checkInvalidActionIdError(response) ||
      this.checkAccessDeniedError(response)
    );
  }

  checkResetPasswordError(
    response: SubmitNewPassword
  ): string | SubmitNewPassword {
    if (this.checkFailValidators(response)) {
      return response;
    } else {
      return this.getMfaRegistrationError(response);
    }
  }
}
